import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-tag-verification-dialog',
  templateUrl: './tag-verification-dialog.component.html',
  styleUrls: ['./tag-verification-dialog.component.scss']
})
export class TagVerificationDialogComponent implements OnInit, OnDestroy {
    @Input() data: any = {};
    @Output() action = new EventEmitter();
    buttonAction = false;
    TagStatus= '137';
    TagStatusMessage = '138'

    Icon = 'fa-phone-square'
    classColor = 'verNotStolen';
    searchVal = '';
    searchTitle = "17";

  constructor(public bsModalRef: BsModalRef, private translate :TranslateService) {
      this.buttonAction = false;
      // console.log('ver dialog',this.data);
  }

  ngOnInit() {
    if (this.data.tag) {
        this.searchVal = this.data.tag;
    }else {
        this.searchTitle = "19";
        this.searchVal = this.data.serial;
    }


    if (this.data.status === 3){
          this.TagStatus= '135';
          this.TagStatusMessage= '136';
         this.Icon = 'fa-exclamation-triangle';
         this.classColor = 'verStolen';
    }

  }

    ngOnDestroy(){
        if (!this.buttonAction){
            this.action.emit({backdropExit: true});
        }
    }

    clickOk() {
        // console.log("Click ok...");
        this.buttonAction = true;
        this.action.emit(true);
        this.bsModalRef.hide();
    }

    cancel() {
        this.buttonAction = true;
        this.bsModalRef.hide();
        this.action.emit(false);
    }

}
